import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="vehicle-makes"
// Populates the make_id select filtered by vehicle type (Carro/Moto).
export default class extends Controller {
  static targets = ["select"];
  static values = { url: String };

  connect() {
    const checked = this.element.querySelector(
      'input[name="vehicle_type"]:checked',
    );
    if (checked) {
      this.loadMakes(checked.value);
    }
  }

  fetchMakes(event) {
    this.loadMakes(event.target.value);
  }

  async loadMakes(vehicleType) {
    const tipo = vehicleType.toLowerCase() === "carro" ? "carro" : "moto";
    const url = `${this.urlValue}?tipo=${tipo}`;

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return;
      const data = await response.json();
      this.populateSelect(data);
    } catch (e) {
      console.error("vehicle-makes: fetch error", e);
    }
  }

  populateSelect(data) {
    const select = this.selectTarget;
    const currentValue = select.value;

    // Destroy existing TomSelect instance
    if (select.tomselect) {
      select.tomselect.destroy();
    }
    delete select._tomSelectInstance;

    // Rebuild options
    select.innerHTML = '<option value="">Selecione a Marca</option>';
    const sorted = [...data].sort(([, a], [, b]) =>
      a.localeCompare(b, "pt-BR"),
    );
    sorted.forEach(([id, name]) => {
      const option = document.createElement("option");
      option.value = id;
      option.textContent = name;
      if (String(id) === String(currentValue)) option.selected = true;
      select.appendChild(option);
    });

    // Re-initialize TomSelect
    select._tomSelectInstance = new TomSelect(select, {
      plugins: ["dropdown_input"],
      allowEmptyOption: true,
      render: {
        no_results: () =>
          '<div class="no-results">Nenhum resultado encontrado</div>',
        loading: () => '<div class="spinner"></div>',
      },
    });
  }
}
